module.exports = __webpack_public_path__ + "img/7_154.27fe1de5.png";